import ace from "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/ext-language_tools";

const commonLatexCommands = [
    "begin", "end", "section", "subsection", "subsubsection",
    "textbf", "textit", "underline", "item", "itemize", "enumerate",
    "label", "ref", "cite", "caption", "includegraphics", "table", "figure",
    "documentclass", "usepackage", "title", "author", "date", "maketitle",
    "frac", "sum", "int", "sqrt", "alpha", "beta", "gamma", "delta",
    "left", "right", "hline", "eqref", "centering", "vfill", "hfill",
    "newpage", "vspace", "hspace", "noindent", "tableofcontents",
    "bibliography", "bibliographystyle", "nocite", "appendix", "chapter",
    "emph", "small", "large", "Large", "LARGE", "huge", "Huge", "indent",
    "column", "row", "multicolumn", "multirow", "tabular"
];

const latexCompleter = {
    getCompletions: function (editor, session, pos, prefix, callback) {
        const text = session.getValue();
        const line = session.getLine(pos.row);
        const col = pos.column;

        const beforeCursor = line.slice(0, col);

        // 1. Check for \ref{ and \cite{
        const refMatch = beforeCursor.match(/\\(ref|cite)\{[^}]*$/);
        if (refMatch) {
            const command = refMatch[1];
            const labels = [];
            const labelRegex = /\\label\{([^}]+)\}/g;
            let match;
            while ((match = labelRegex.exec(text)) !== null) {
                labels.push(match[1]);
            }
            const bibitems = [];
            const bibRegex = /\\bibitem\{([^}]+)\}/g;
            while ((match = bibRegex.exec(text)) !== null) {
                bibitems.push(match[1]);
            }
            const suggestions = command === "ref" ? labels : bibitems;
            const filtered = suggestions.filter(s => s.startsWith(prefix));

            callback(null, filtered.map(s => ({
                caption: s,
                value: s,
                meta: command === "ref" ? "label" : "bibitem",
                score: 100000 // Huge score
            })));
            return;
        }

        // 2. Check if we are typing a command (after a backslash)
        const commandMatch = beforeCursor.match(/\\([a-zA-Z]*)$/);
        if (commandMatch) {
            const cmdPrefix = commandMatch[1];
            const completions = commonLatexCommands
                .filter(cmd => cmd.startsWith(cmdPrefix))
                .map(cmd => ({
                    caption: "\\" + cmd,
                    value: cmd,
                    meta: "keyword",
                    score: 900000 // Very huge score
                }));
            callback(null, completions);
            return;
        }

        callback(null, []);
    }
};

export function setupLatexAutocomplete(aceRef) {
    if (!aceRef?.current?.editor) return;
    const editor = aceRef.current.editor;

    const langTools = ace.require("ace/ext/language_tools");
    if (langTools) {
        // Find default completers
        // 1. snippetCompleter (templates)
        // 2. textCompleter (The "local" one we want to block)
        // 3. keyWordCompleter (Standard LaTeX keywords from the mode)
        const defaultCompleters = langTools.setCompleters ? [] : (langTools.completers || []);
        
        // We want to keep everything EXCEPT the 'textCompleter'
        // But since we want strict control, we'll build our specific list:
        const keyWordCompleter = langTools.keyWordCompleter;

        const activeCompleters = [latexCompleter];
        if (keyWordCompleter) activeCompleters.push(keyWordCompleter);
        
        langTools.setCompleters(activeCompleters);
        editor.completers = activeCompleters;
    }
}
